// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"4ce20330","244":"93c84768","426":"f1945710","453":"d67139e5","673":"867fed0f","694":"34a54579","723":"d6d71a04","732":"2a6b0a0c","765":"0a73dc11"}[chunkId] + ".chunk.js";
};